// escapeHtml экранирует пользовательские данные перед вставкой в HTML-строки
// (balloonContent / hintContent Yandex Maps, SVG-аватары и т.п.), где React
// auto-escaping не работает. Защита от stored XSS через имена, адреса, email.
export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}